<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageIndex' }"
          >知识付费内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>知识付费详情设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>知识付费详情设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <!-- 商品详情编辑内容 -->
          <div class="product_details_edit">
            <!-- 编辑内容展示 -->
            <div class="product_details_content" v-if="contents.length > 0">
              <div
                class="product_details_item"
                v-for="(item, index) in contents"
                :key="index"
              >
                <!-- 子内容操作 -->
                <div class="product_details_item_operate flex-between">
                  <div class="txt">
                    {{
                      item.conttype == 1
                        ? "图片"
                        : item.conttype == 2
                        ? "视频"
                        : "文本"
                    }}
                  </div>
                  <div class="operate_group flex-rowr">
                    <div
                      class="btn flex-rowc"
                      :class="{ disable: index === 0 }"
                      @click="moveUp(index)"
                      :disabled="index === 0"
                    >
                      上移
                    </div>
                    <div
                      class="btn flex-rowc"
                      :class="{ disable: index === contents.length - 1 }"
                      @click="moveDown(index)"
                      :disabled="index === contents.length - 1"
                    >
                      下移
                    </div>
                    <div
                      class="btn flex-rowc"
                      :class="{ disable: index === 0 }"
                      @click="moveToTop(index)"
                      :disabled="index === 0"
                    >
                      置顶
                    </div>
                    <div class="btn flex-rowc" @click="addContent(item.sortno)">
                      新增
                    </div>
                    <div class="btn flex-rowc" @click="deleteContent(index)">
                      移除
                    </div>
                  </div>
                </div>
                <!-- 子内容展示 -->
                <div class="product_details_item_content">
                  <!-- 图片 -->
                  <div class="pic_box" v-if="item.conttype == 1">
                    <div @click="openFileInputImg(item.id)">
                      <img :src="item.picurl" alt="" />
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div class="video_box" v-if="item.conttype == 2">
                    <div @click="openFileInputVideo(item.id)">
                      <video :src="item.videourl" controls></video>
                    </div>
                  </div>
                  <!-- 文本 -->
                  <div class="txt_box" v-if="item.conttype == 3">
                    <el-input
                      type="textarea"
                      v-model="item.details"
                      placeholder="请输入文字内容"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <!-- 编辑操作 -->
            <div class="product_details_operate flex-between">
              <div class="txt">内容</div>
              <div class="operate_group flex-rowr">
                <div class="btn flex-rowc" @click="addTextContent">
                  + 新增文字内容
                </div>
                <div class="btn flex-rowc" @click="openFileInputImg('')">
                  + 新增图片内容
                </div>
                <div class="btn flex-rowc" @click="openFileInputVideo('')">
                  + 新增视频内容
                </div>
              </div>
            </div>

            <input
              type="file"
              ref="fileInputImg"
              style="display: none"
              @change="addImageContent"
              accept="image/*"
            />
            <input
              type="file"
              ref="fileInputVideo"
              style="display: none"
              @change="addVideoContent"
              accept="video/*"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="isShowContentSelect">
      <div class="popup_add_wrap">
        <div class="popup_add_content">
          <div class="add_item flex-rowc" @click="addTextContent">
            <i class="iconfont icon-a-bianji2"></i> 向下添加文字
          </div>
          <div class="add_item flex-rowc" @click="openFileInputImg('')">
            <i class="iconfont icon-tupian"></i> 向下添加图片
          </div>
          <div class="add_item flex-rowc" @click="openFileInputVideo('')">
            <i class="iconfont icon-shipinsheying"></i> 向下添加视频
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  uploadImage,
  delShopDetail,
  getUploadToken,
  encryptstringview,
} from "../../../api/api";
import {
  getKonwledgeContentList,
  editKonwledgeContent,
  addKonwledgeContent,
} from "../../../api/knowledge";
export default {
  name: "kDetail",
  data() {
    return {
      params: {
        kpid: "",
        keyword: "",
      },
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        intro: "", // 商品简介
        Specifications: "", // 商品规格描述
        details1: "",
        details2: "",
        details3: "",
        // details: "",
      },

      loading: false,
      loadingText: "请稍后",

      kpid: "",
      isShowContentSelect: false,
      editId: "", // 修改图片、视频的id
      addIndex: "",
      oldContentsLength: 1,
      // 删除内容id
      deleteContentsId: [],
      // 编辑内容
      contents: [],
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.kpid = id;
        this.params.kpid = id;
        this.getKonwledgeContentList();
      } else {
        this.$router.back();
      }
    },

    getKonwledgeContentList() {
      this.loading = true;
      getKonwledgeContentList(this.params).then((res) => {
        this.contents = res.list;
        this.loading = false;
      });
    },

    /**
     * 编辑商品详情
     * **/
    // 1、新增文字内容
    addTextContent() {
      let { contents, addIndex, kpid } = this;
      if (addIndex === "") {
        let sortno = contents.length + 1; // 根据数组长度设置排序值
        contents.push({
          kpid,
          sortno,
          conttype: 3,
          picurl: "",
          videourl: "",
          details: "",
        });
        // this.updateSort();
      } else {
        this.isShowContentSelect = false;
        this.contents.splice(addIndex + 1, 0, {
          kpid,
          sortno: addIndex,
          conttype: 3,
          picurl: "",
          videourl: "",
          details: "",
        });
        this.addIndex = "";
        this.updateSort(true);
      }
    },

    // 2、新增图片内容
    openFileInputImg(id) {
      this.editId = id;
      this.$refs.fileInputImg.click();
    },
    // 图片上传后处理
    addImageContent(e) {
      const formData = new FormData();
      formData.append("imgfile", e.target.files[0]);
      this.loading = true;
      let { contents, addIndex, kpid, editId } = this;
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (editId != "") {
            contents.forEach((v) => {
              if (v.id == editId) {
                v.picurl = res.url;
              }
            });
          } else {
            if (addIndex === "") {
              let sortno = contents.length + 1; // 根据数组长度设置排序值
              contents.push({
                kpid,
                sortno,
                conttype: 1,
                picurl: res.url,
                videourl: "",
                details: "",
              });
              // this.updateSort();
            } else {
              this.isShowContentSelect = false;
              this.contents.splice(addIndex + 1, 0, {
                kpid,
                sortno: addIndex,
                conttype: 1,
                picurl: res.url,
                videourl: "",
                details: "",
              });
              this.addIndex = "";
              this.updateSort(true);
            }
          }
          this.loading = false;
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 3、新增视频内容
    openFileInputVideo(id) {
      this.editId = id;
      this.$refs.fileInputVideo.click();
    },
    addVideoContent(e) {
      let { contents, addIndex, kpid, editId } = this;
      this.loading = true;
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.target.files[0]);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                //返回数据根据结果进行相应的处理
                if (editId != "") {
                  contents.forEach((v) => {
                    if (v.id == editId) {
                      v.videourl = res.host + "/" + res.key;
                    }
                  });
                } else {
                  if (addIndex === "") {
                    let sortno = contents.length + 1; // 根据数组长度设置排序值
                    contents.push({
                      kpid,
                      sortno,
                      conttype: 2,
                      picurl: "",
                      videourl: res.host + "/" + res.key,
                      details: "",
                    });
                    // this.updateSort();
                  } else {
                    this.isShowContentSelect = false;
                    this.contents.splice(addIndex + 1, 0, {
                      kpid,
                      sortno: addIndex,
                      conttype: 2,
                      picurl: "",
                      videourl: res.host + "/" + res.key,
                      details: "",
                    });
                    this.addIndex = "";
                    this.updateSort(true);
                  }
                }
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      this.loadingText = `上传:${progress}%`;
      if (progress == 100) {
        this.loading = false;
      }
    },

    // 4、上移
    moveUp(index) {
      if (index > 0) {
        const tempSort = this.contents[index].sortno;
        this.contents[index].sortno = this.contents[index - 1].sortno;
        this.contents[index - 1].sortno = tempSort;
        this.contents.sort((a, b) => a.sortno - b.sortno); // 排序数组
      }
    },
    // 5、下移
    moveDown(index) {
      if (index < this.contents.length - 1) {
        const tempSort = this.contents[index].sortno;
        this.contents[index].sortno = this.contents[index + 1].sortno;
        this.contents[index + 1].sortno = tempSort;
        this.contents.sort((a, b) => a.sortno - b.sortno); // 排序数组
      }
    },
    // 6、置顶
    moveToTop(index) {
      const item = this.contents[index];
      this.contents.splice(index, 1);
      this.contents.unshift(item);
      this.updateSort(); // 更新排序属性
    },
    // 7、删除
    deleteContent(index) {
      let deletedElements = this.contents.splice(index, 1);
      if (deletedElements[0].id) {
        let arrId = [];
        arrId.push(deletedElements[0].id);
        this.deleteContentsId = this.deleteContentsId.concat(...arrId);
      }
      this.updateSort();
    },
    // 8、新增
    addContent(index) {
      this.addIndex = index;
      this.isShowContentSelect = true;
    },
    // 正常重新更新排序
    updateSort(isTrue) {
      if (isTrue) {
        this.contents.sort((a, b) => a.sortno - b.sortno);
      }
      this.contents.forEach((item, index) => {
        item.sortno = index + this.oldContentsLength;
      });
    },

     // 新增/修改内容
    async submitItem(item) {
      const request = item.id ? editKonwledgeContent : addKonwledgeContent;
      try {
        const res = await request(item);
        console.log(res, "=========");
        return true;
      } catch (error) {
        console.error("提交失败", error);
        return false;
      }
    },

    // 删除内容
    async deleteItem(id) {
      if (id) {
        try {
          const res = await delShopDetail({ id });
          console.log(res, "=========res");
          return true;
        } catch (error) {
          console.error("删除失败", error);
          return false;
        }
      }
    },

    // 提交数据
    async submitData() {
      const { contents, deleteContentsId } = this;
      let deleteSuccess = true;
      let addSuccess = true;

      // 处理删除数据
      if (deleteContentsId.length > 0) {
        deleteSuccess = await this.processItems(
          deleteContentsId,
          this.deleteItem
        );
      }

      // 处理新增数据
      if (contents.length > 0) {
        addSuccess = await this.processItems(contents, this.submitItem);
      }

      this.loading = false;
      console.log(deleteSuccess, "======", addSuccess);

      if (deleteSuccess && addSuccess) {
        this.$message.success("提交成功");
      } else {
        this.$message.error("部分内容提交失败，请检查网络或联系管理员");
      }
    },

    // 处理操作（删除/新增）
    async processItems(items, operation) {
      let success = true;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const res = await operation(item);
        if (!res) {
          success = false;
        }
      }
      return success;
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "kManageIndex" });
    },

    query() {
      let { formData, contents } = this;
      if (contents.length == 0) {
        this.$message("请新增内容");
        return;
      }
      console.log(contents, formData, "====-=formData=====");
      this.loading = true;
      this.submitData();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        .form_item {
          margin-bottom: 40px;
          .block {
            margin-bottom: 25px;
          }
        }
      }
    }
  }
  .product_details_edit {
    width: 100%;
    padding: 0 0 70px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 50px;
          border: 1px solid #d2d2d2;
          font-size: 14px;
          padding: 0 22px;
          box-sizing: border-box;
          margin-bottom: 10px;
          .txt {
            font-size: 16px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 25px;
              padding: 0 14px;
              margin-left: 20px;
              cursor: pointer;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 15px 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 15px 20px 20px;
      .txt {
        font-size: 16px;
        white-space: nowrap;
      }
      .btn {
        font-size: 14px;
        color: #ffffff;
        height: 30px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        cursor: pointer;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
  .popup_add_wrap {
    font-size: 18px;
    .popup_add_content {
      .add_item {
        cursor: pointer;
        height: 70px;
        border-bottom: 2px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        .iconfont {
          font-size: 26px;
          margin-right: 10px;
        }
      }
    }
    .popup_add_cancle {
      height: 100px;
      border-top: 5px solid #ededed;
    }
  }
}
</style>